import PropTypes from 'prop-types';
import React from 'react';
import LicenceType from '../licence-type/LicenceType';

var TitleDateCopyright = function TitleDateCopyright(_ref) {
  var title = _ref.title,
      url = _ref.url,
      owns = _ref.owns,
      licences = _ref.licences;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__title-date-copyright"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
    className: "dashboard-card__title-date-copyright__title",
    href: url
  }, title)), /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__title-date-copyright__date-copyright"
  }, owns && licences && /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__author-price-views__price"
  }, /*#__PURE__*/React.createElement(LicenceType, {
    licences: licences
  }))));
};

TitleDateCopyright.displayName = "TitleDateCopyright";
TitleDateCopyright.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  owns: PropTypes.bool,
  licences: PropTypes.arrayOf(PropTypes.string)
};
TitleDateCopyright.defaultProps = {
  owns: false,
  licences: []
};
export default TitleDateCopyright;